// This file can be replaced during build by using the `fileReplacements` array.

export const environment = {
  production: false,
};
